import { Button, type ButtonProps, Tooltip } from '@skupreme/shared/ui';

export const READ_ONLY_HINT =
  'Your role can view mappings but not change them. Ask an admin or catalog editor.';

export type GatedButtonProps = ButtonProps & {
  /** The user can't change mappings: the button is disabled and says why on hover. */
  isReadOnly?: boolean;
};

/** A button for an action that needs catalog write access. */
export function GatedButton({
  isReadOnly,
  isDisabled,
  ...props
}: GatedButtonProps) {
  const button = <Button {...props} isDisabled={isDisabled || isReadOnly} />;

  return isReadOnly ? (
    <Tooltip content={READ_ONLY_HINT}>{button}</Tooltip>
  ) : (
    button
  );
}
